import { useEffect, useState } from "react";
import CardTask from "../../components/Card/CardTask";
import { Link, useHistory, useLocation, useRouteMatch } from "react-router-dom";
import SearchBar from "../../components/Searchbar";
import { getLearningMyTask } from "../../redux/actions/learningMyTask";
import { useDispatch, useSelector } from "react-redux";
import TaskModal from "./TaskModal";
import ButtonBlue from "../../components/Button/ButtonBlue";
import { IoCloseOutline, IoFilterOutline } from "react-icons/io5";
import {
  Card,
  SideBarActiveCount,
  SideBarActiveDiv,
  SideBarActiveDivButtonNew,
  SideBarActiveDivNew,
  SideBarNormalCount,
  SideBarNormalDiv,
  SideBarNormalDivButtonNew,
  SideBarNormalDivNew,
} from "../Theme";

const assignment = [
  {
    title: "Assignment 5",
    assigned: "20 Sept 21",
    due: "25 Sept 21",
    icon: "25",
    description:
      "This is a container for assignment description. Assignment description goes here. Example text to fill",
    task: [
      { id: 1, name: "Example task number 1", completed: false },
      { id: 2, name: "Example task number 2", completed: false },
      { id: 3, name: "Example task number 3", completed: true },
    ],
  },
  {
    title: "Assignment 6",
    assigned: "19 Sept 21",
    due: "30 Sept 21",
    icon: "30",
    description:
      "This is a container for assignment description. Assignment description goes here. Example text to fill",
    task: [
      { id: 1, name: "Example task number 1", completed: true },
      { id: 2, name: "Example task number 2", completed: false },
      { id: 3, name: "Example task number 3", completed: false },
    ],
  },
  {
    title: "Assignment 1",
    assigned: "15 Sept 21",
    due: "21 Sept 21",
    icon: "21",
    description:
      "This is a container for assignment description. Assignment description goes here. Example text to fill",
    task: [
      { id: 1, name: "Example task number 1", completed: false },
      { id: 2, name: "Example task number 2", completed: false },
      { id: 3, name: "Example task number 3", completed: true },
    ],
  },
  {
    title: "Assignment 2",
    assigned: "19 Sept 21",
    due: "24 Sept 21",
    icon: "24",
    description:
      "This is a container for assignment description. Assignment description goes here. Example text to fill",
    task: [
      { id: 1, name: "Example task number 1", completed: false },
      { id: 2, name: "Example task number 2", completed: false },
      { id: 3, name: "Example task number 3", completed: true },
    ],
  },
  {
    title: "Assignment 3",
    assigned: "19 Sept 21",
    due: "25 Sept 21",
    icon: "25",
    description:
      "This is a container for assignment description. Assignment description goes here. Example text to fill",
    task: [
      { id: 1, name: "Example task number 1", completed: true },
      { id: 2, name: "Example task number 2", completed: false },
      { id: 3, name: "Example task number 3", completed: false },
    ],
  },
  {
    title: "Assignment 4",
    assigned: "19 Sept 21",
    due: "24 Sept 21",
    icon: "24",
    description:
      "This is a container for assignment description. Assignment description goes here. Example text to fill",
    task: [
      { id: 1, name: "Example task number 1", completed: true },
      { id: 2, name: "Example task number 2", completed: false },
      { id: 3, name: "Example task number 3", completed: false },
    ],
  },
  {
    title: "Assignment 5",
    assigned: "22 Sept 21",
    due: "27 Sept 21",
    icon: "27",
    description:
      "This is a container for assignment description. Assignment description goes here. Example text to fill",
    task: [
      { id: 1, name: "Example task number 1", completed: true },
      { id: 2, name: "Example task number 2", completed: false },
      { id: 3, name: "Example task number 3", completed: false },
    ],
  },
];

export default function MyTask() {
  const history = useHistory();
  const location = useLocation();
  const { path } = useRouteMatch();
  const dispatch = useDispatch();
  const taskList = useSelector((state) => state.learningMyTask.taskList);

  const [searchField, setSearchField] = useState("");
  const [task, setTask] = useState({});
  const [title, setTitle] = useState("");
  const [taskModal, setTaskModal] = useState(false);
  const [filteredAssignments, setFilteredAssignments] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("-1");
  const [listName, setListName] = useState("");
  const [modal, setModal] = useState(false);

  const openModal = (title, task) => {
    setTaskModal(true);
    setTask(task);
    setTitle(title);
  };

  const closeModal = () => setTaskModal(false);

  useEffect(() => {
    // Status filter
    if (selectedStatus === "-1") {
      var selectedTask = taskList.filter((task) => true);
    } else if (selectedStatus === "progress") {
      var selectedTask = taskList.filter(
        (task) => task.task_done < task.task_count
      );
    } else {
      var selectedTask = taskList.filter(
        (task) => task.task_done === task.task_count
      );
    }

    // Search
    const filteredList = selectedTask.filter((item) =>
      // item.list_name?.toString().toLowerCase().includes(searchField.toLowerCase()
      Object.keys(item).some((key) =>
        item[key]?.toString().toLowerCase().includes(searchField.toLowerCase())
      )
    );

    setFilteredAssignments(filteredList);
  }, [taskList, searchField, selectedStatus]);

  useEffect(() => {
    dispatch(getLearningMyTask());
  }, []);

  const Tab = ({ text, active, ...props }) => {
    let style = "font-14px font-medium cursor-pointer hover:text-blue-500";
    return active ? (
      <SideBarActiveDiv className={style}>{text}</SideBarActiveDiv>
    ) : (
      <SideBarNormalDiv className={style}>{text}</SideBarNormalDiv>
    );
  };

  return (
    <div className="flex flex-col md:flex-col lg:flex-row ">
      <div className="flex flex-row-reverse lg:flex-col border-right-f1">
        <div className="px-4 w-full border-bottom-f1 pt-4 pb-3 md:pt-6 md:pb-6 box-border">
          <SearchBar setSearchField={setSearchField} />
        </div>
        <div className="lg:w-64 md:top-32 flex flex-row lg:flex-col-reverse">
          <div className="lg:hidden border-bottom-f1 flex items-center">
            <div className="bg-white flex items-center h-12 pl-10 pr-4 mr-4">
              <IoFilterOutline
                className="w-6 h-6 cursor-pointer"
                onClick={() => setModal(true)}
              />
            </div>
          </div>
          <Card
            className={
              modal
                ? `inline-block lg:bg-white lg:bg-opacity-100 
                                 lg:mt-0 bg-black bg-opacity-60 w-full h-[calc(100vh-88px)]  
                                overflow-auto lg:pr-20 fixed topbar-offset lg:relative z-50 pr-16 `
                : `hidden lg:inline-block lg:bg-opacity-100 
                                mt-20 lg:mt-0 lg:rounded-lg 
                                 fixed top-0 lg:relative z-10 pb-6`
            }
            // style={{ height: "100%" }}
          >
            <>
              <div
                className="flex pt-5 pb-3 pl-2 lg:pt-0 lg:mt-3  pr-2 items-center cursor-pointer border-bottom-f1"
                onClick={() => {
                  setSelectedStatus("-1");
                }}
              >
                {selectedStatus === "-1" ? (
                  <SideBarActiveDivNew
                    className={`font-14px font-bold cursor-pointer w-full py-1 pl-2 `}
                  >
                    All tasks
                  </SideBarActiveDivNew>
                ) : (
                  <SideBarNormalDivNew
                    className={`font-14px font-bold cursor-pointer w-full py-1 pl-2 `}
                  >
                    All tasks
                  </SideBarNormalDivNew>
                )}
              </div>

              <div className="w-full px-4">
                <div className={` pb-6 pt-3`}>
                  <div className="flex  items-center justify-between cursor-pointer">
                    <Tab
                      text="Status"
                      active={
                        selectedStatus === "progress" ||
                        selectedStatus === "completed"
                      }
                    />
                    {/* {!sidebar ? (
                      <MdKeyboardArrowDown className="blueColor" size={20} />
                    ) : (
                      <MdKeyboardArrowRight className="blueColor" size={20} />
                    )} */}
                  </div>
                  <div
                    className={
                      "flex flex-col flex-1 mt-2 border-left-f1 ml-1 pl-2"
                    }
                  >
                    {selectedStatus === "progress" ? (
                      <SideBarActiveDivButtonNew
                        type="button"
                        className={`font-14px flex items-center justify-between text-left whitespace-normal py-1 my-1 pl-2 pr-2 w-full cursor-pointer font-medium`}
                        onClick={(e) => setSelectedStatus("progress")}
                      >
                        In progress
                        <SideBarActiveCount className="inline-flex items-center justify-center p-1 text-center text-xs w-6 h-6">
                          {
                            taskList.filter(
                              (task) => task.task_done < task.task_count
                            ).length
                          }
                        </SideBarActiveCount>
                      </SideBarActiveDivButtonNew>
                    ) : (
                      <SideBarNormalDivButtonNew
                        type="button"
                        className={`font-14px flex items-center justify-between text-left whitespace-normal lightColor pl-2 pr-2 my-1 pb-1 pt-1 w-full cursor-pointer font-medium`}
                        onClick={(e) => setSelectedStatus("progress")}
                      >
                        In progress
                        <SideBarNormalCount className="inline-flex flex-shrink-0items-center justify-center p-1 text-center text-xs w-6 h-6">
                          {
                            taskList.filter(
                              (task) => task.task_done < task.task_count
                            ).length
                          }
                        </SideBarNormalCount>
                      </SideBarNormalDivButtonNew>
                    )}
                    {selectedStatus === "completed" ? (
                      <SideBarActiveDivButtonNew
                        type="button"
                        className={`font-14px flex items-center justify-between text-left whitespace-normal py-1 my-1 pl-2 pr-2 w-full cursor-pointer font-medium`}
                        onClick={(e) => setSelectedStatus("completed")}
                      >
                        Completed
                        <SideBarActiveCount className="inline-flex items-center justify-center p-1 text-center text-xs w-6 h-6">
                          {
                            taskList.filter(
                              (task) => task.task_done === task.task_count
                            ).length
                          }
                        </SideBarActiveCount>
                      </SideBarActiveDivButtonNew>
                    ) : (
                      <SideBarNormalDivButtonNew
                        type="button"
                        className={`font-14px flex items-center justify-between text-left whitespace-normal lightColor pl-2 pr-2 my-1 pb-1 pt-1 w-full cursor-pointer font-medium`}
                        onClick={(e) => setSelectedStatus("completed")} 
                      >
                        Completed
                        <SideBarNormalCount className="inline-flex flex-shrink-0items-center justify-center p-1 text-center text-xs w-6 h-6">
                          {
                            taskList.filter(
                              (task) => task.task_done === task.task_count
                            ).length
                          }
                        </SideBarNormalCount>
                      </SideBarNormalDivButtonNew>
                    )}
                  </div>
                </div>
              </div>
              <div
                className="absolute top-5 right-10 lg:hidden text-gray-400 cursor-pointer"
                onClick={() => setModal(false)}
              >
                <IoCloseOutline className="w-8 h-8" />
              </div>
            </>
          </Card>
        </div>
      </div>
      <div className="w-full backGroundColor border20pxbottomright lg:rounded-bl-none rounded-bl-2xl">
        <TaskModal
          onClose={closeModal}
          show={taskModal}
          title={title}
          task={task}
        />

        <div className="flex gap-3 py-8 px-2 md:px-6 cardBackgroundColor items-center justify-between flex-wrap">
          <p className="flex items-center justify-center text-sm md:text-md lg:text-base">
            Showing {filteredAssignments.length} of {taskList.length}{" "}
            assignments
          </p>
          <div className="block lg:hidden">
            <ButtonBlue
              onClick={() => history.push(`/tasks/new`)}
              title={"+ Add Task List"}
              width="full"
            />
          </div>
        </div>
        <div className="grid p-2 md:p-5 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 md:gap-5">
          {filteredAssignments.length > 0 &&
            filteredAssignments.map((list, index) => {
              return (
                <Link
                  key={index}
                  className="hover:no-underline flex"
                  to={{
                    pathname: "/tasks/mytask/detail/" + list.id,
                    src: location.pathname,
                  }}
                >
                  <CardTask
                    id={list.id}
                    data={list}
                    openModal={() => openModal(list.list_name, list.tasks)}
                    isMyTask={true}
                  />
                </Link>
              );
            })}
        </div>
      </div>
    </div>
  );
}
